module.exports = __webpack_public_path__ + "img/56.30e337d6.png";